<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Interface Configurations</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Interface Configurations</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="overlay" v-if="is_loading">
        <img src="/assets/images/loader.svg" alt="" />
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="overlay" v-if="is_loading">
              <img src="/assets/images/loader.svg" alt="" />
            </div>
            <div class="card-header">
              <h3 class="card-title">Detail</h3>
              <div class="card-tools">
                <router-link
                  class="btn btn-info"
                  :to="{ name: 'InterfaceConfigurationList' }"
                >
                  <i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="custom-list">
                <ul>
                  <li><strong>ID</strong> {{ value.id }}</li>

                  <li><strong>Audra Name</strong> {{ value.ap_wi_mac }}</li>

                  <li><strong>Description</strong> {{ value.description }}</li>

                  <li>
                    <strong>Interface Type</strong> {{ value.interface_type }}
                  </li>

                  <li><strong>Interface</strong> {{ value.interface }}</li>

                  <li><strong>Protocol</strong> {{ value.protocol }}</li>

                  <li>
                    <strong>Network Address</strong> {{ value.network_addr }}
                  </li>

                  <li><strong>Gateway</strong> {{ value.gateway }}</li>

                  <li><strong>User ID</strong> {{ value.user_id }}</li>

                  <li><strong>Password</strong> {{ value.password }}</li>

                  <li>
                    <strong>Service Name</strong> {{ value.service_name }}
                  </li>

                  <li><strong>DNS</strong> {{ value.dns }}</li>

                  <li>
                    <strong>Alternate DNS</strong> {{ value.alternate_dns }}
                  </li>

                  <li><strong>VLAN Number</strong> {{ value.vlan_no }}</li>

                  <li><strong>Labeling</strong> {{ value.labeling }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
//import MasterLayout from "@/components/layouts/MasterLayoutComponent.vue";
import { DepartmentsAPI } from '@/services/api'
import axios from 'axios'
const fileDownload = require('js-file-download')
import { Notification } from 'element-ui'

export default {
  name: 'InterfaceConfigurationShow',
  metaInfo: {
    title: 'Interface Configurations | Dotlines'
  },
  data: () => ({
    value: {},
    pre: {},
    is_loading: false
  }),
  mounted: function () {
    this.initialize()
  },
  methods: {
    async initialize () {
      this.is_loading = true
      this.params = this.$route.params

      await this.getDetail(this.params.id).then(response => {
        this.value = response.data
      })

      this.is_loading = false
    },
    downloadFile: function (url) {
      this.is_loading = true
      axios
        .get(this.API_ASSET_UPLOAD_URL + url, { responseType: 'arraybuffer' })
        .then(response => {
          fileDownload(response.data, url.replaceAll('/', '-'))
          Notification.success({
            title: 'Download Completed',
            message: 'Download completed successfully',
            type: 'success'
          })
        })
        .catch(error => {
          Notification.error({
            title: 'Download Failed',
            message: 'Failed to download',
            type: 'error'
          })
        })
        .finally(() => {
          this.is_loading = false
        })
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = '/interface_configurations/' + id
        axios
          .get(api_url)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            console.log('error ' + error)
            reject(error)
          })
          .finally(() => {})
      })
    }
  }
  /*created() {
    this.$emit("update:layout", MasterLayout);
  },*/
}
</script>
